/**
 * Tight axis-aligned bounding box of foreground (mask value 1) in pixel coordinates.
 * maxX/maxY are exclusive (suitable for width = maxX - minX).
 */

/**
 * @param {Uint8Array} mask
 * @param {number} width
 * @param {number} height
 * @returns {{ minX: number, minY: number, maxX: number, maxY: number } | null}
 */
export function computeMaskBoundingBox(mask, width, height) {
  let minX = width;
  let minY = height;
  let maxX = 0;
  let maxY = 0;

  for (let y = 0; y < height; y += 1) {
    const row = y * width;
    for (let x = 0; x < width; x += 1) {
      if (mask[row + x] !== 1) continue;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x + 1 > maxX) maxX = x + 1;
      if (y + 1 > maxY) maxY = y + 1;
    }
  }

  if (minX >= maxX || minY >= maxY) return null;
  return { minX, minY, maxX, maxY };
}
